import { Route } from 'react-router-dom'
import { URLS } from './constants'
import { PrivateRoute } from 'components/utils/PrivateRoute'
import { Locations } from './Locations'
import { Location } from './Location'

export const useLocationRoutes = applicationPages => {
  return (
    <>
      <Route
        path={URLS.AUTH_LOCATION_MANAGEMENT}
        element={
          <PrivateRoute component={Locations} applicationPages={applicationPages} />
        }
      />
      <Route
        path={URLS.AUTH_LOCATION_MANAGEMENT_DETAILS}
        element={
          <PrivateRoute component={Location} applicationPages={applicationPages} />
        }
      />
    </>
  )
}
